const getTenantId = () => {
  const tenantId = 1;
  return tenantId;
};

export { getTenantId };
